import React, { useState } from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import session from "../api/session"; 
import { SuperVisorModal } from "./modal-supervisor.jsx"; 


export default function AFMRecognition() {
  const [afm, setAfm] = useState("");
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");
  const [results, setResults] = useState([]); 
  const [selectedFleaMarket, setSelectedFleaMarket] = useState(""); 
  const [openModalFor, setOpenModalFor] = useState(null); 
  const [benchViolations, setBenchViolations] = useState([]); 

  
  React.useEffect(() => {
    session.get("api/bench-violations/").then(resp => {
      setBenchViolations(resp.data || []);
    }).catch(() => {});
  }, []);



  const handleSearch = async () => {
    const val = (afm || "").trim();
    if (!val) {
      setMsg("Εισάγετε ΑΦΜ");
      setResults([]);
      return;
    }

    
    if (!val.length == 9 ) {
      setMsg("Το ΑΦΜ πρέπει να είναι 9 ψηφία");
      setResults([]);
      return;
    }

    setLoading(true);
    setMsg("");
    try {
      
      const resp = await session.get(`/api/pagkoi-by-afm/?afm=${encodeURIComponent(val)}${selectedFleaMarket ? `&laikiAgoraId=${selectedFleaMarket}` : ""}`);
      const data = resp.data?.results ?? resp.data ?? [];
      setResults(Array.isArray(data) ? data : []);
      if (!data || data.length === 0) setMsg("Δεν βρέθηκαν πάγκοι για το ΑΦΜ");
    } catch (e) {
      console.error(e);
      setMsg("Σφάλμα κατά την αναζήτηση (κοιτάξτε console)");
      if (e?.response?.data?.detail === "Signature has expired.") {
        window.location.href = "/yp";
      }
    } finally {
      setLoading(false);
    }
  };

  const handleUpdatedPagkos = (updated) => {
    if (! updated || !updated.id) return;
    setResults(prev => prev.map(r => (r.id === updated.id ? {...r, ...updated } : r)));
    
  }

  return (
    <Box sx={{ mt: 2 }}>
      <Box sx={{ display: "flex", gap: 1, alignItems: "center", mb: 2 }}>
        <TextField
          label="ΑΦΜ"
          value={afm}
          onChange={(e) => setAfm(e.target.value)}
          variant="outlined"
          size="small"
        />
        <Button variant="contained" onClick={handleSearch} sx={{ textTransform: "none" }}>
          Αναζήτηση ΑΦΜ
        </Button>
        {loading && <CircularProgress size={24} sx={{ ml: 1 }} />}
      </Box>

      <Box sx={{ color: "red", mb: 2 }}>{msg}</Box>

        {/* Results list */}
        <Box>
            {results && results.length > 0 ? (
            <Box>
                <h4>Αποτελέσματα ({results.length})</h4>
                <ul>
                {results.map((r) => (
                    <li key={r.id} style={{ marginBottom: 8 }}>
                    <strong>{r.userIdp ?? r.nameP ?? "Άγνωστος"}</strong>
                    {" — "}
                    Πάγκος: {r.nameP ?? r.anagnwristikoP ?? r.barcode}
                    {" — "}
                    Αναγνωριστικό: {r.anagnwristikoP ?? "-"}
                    {" "}
                    <Button
                        size="small"
                        variant="outlined"
                        sx={{ ml: 1, textTransform: "none" }}
                        onClick={() => setOpenModalFor(r)}
                    >
                        Έλεγχος
                    </Button>
                    </li>
                ))}
                </ul>
            </Box>
            ) : (
            <Box>Δεν υπάρχουν αποτελέσματα</Box>
            )}
        </Box>

        {openModalFor && (
            <SuperVisorModal
            open={true}
            onClose={() => setOpenModalFor(null)}
            onUpdated={handleUpdatedPagkos}
            key={openModalFor.id}
            benchAfm={openModalFor.afmP}
            name={openModalFor.userIdp}
            numberP={openModalFor.nameP}
            licenseStart={openModalFor.enarxiAP}
            licenceEnd={openModalFor.lixiAP}
            squares={openModalFor.tetragwnika}
            barcode={openModalFor.barcode}
            qrcode={openModalFor.qr_code}
            anastoli={openModalFor.anastoli}
            adeiaAllouDimou={openModalFor.adeiaAllouDimou}
            diakopi={openModalFor.diakopi}
            pagkosID={openModalFor.id}
            anagnwristikoPagkou={openModalFor.anagnwristikoP}
            benchPosition={openModalFor.bench_position}
            tetragwnika={openModalFor.tetragwnika}
            endBenchInspection={() => { setOpenModalFor(null); }}
            benchViolations={benchViolations}
            selectedBenchViolations={openModalFor.violations}

            laikiAgora={openModalFor.laikiAgoraId}
            />
        )}
    </Box>
  );
}
